import { render } from "./ArrowDown.vue?vue&type=template&id=213c4aea&ts=true"
import script from "./ArrowDown.vue?vue&type=script&lang=ts"
export * from "./ArrowDown.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__